(function() {
  window.packService = {
    get() {
      return axios.get(`/api/pack/get.php`);
    },
    save(data) {
      return axios.post('/api/pack/save.php', data);
    },
    getReceived(data) {
      return axios.get('/api/user/pack/received.php');
    },
    saveReceived(data) {
      return axios.post('/api/user/pack/received.php', data);
    },
    getStreamerPacks(){
      return axios.get( `/api/user/subscription/get.php?twitchId=${utils.cookies.get('user_id')}`)
    },
    getStreamer(){
      return axios.get(`/api/pack/get.php?streamer=true`);
    }
  }
})();